// Development : if you have update cache issues, add ?v=1 to the end of the import and change the version for each edit
import CustomerReviews from "./CustomerReviews.js";
let reviews = new CustomerReviews(document.querySelector('#customers-reviews').getAttribute('data-product-ids'));
reviews.init(() => {
  reviews.generateHtml();
});

// Open reviews drawer if hash is #reviews
window.onhashchange = openReviewsfromHash;
document.addEventListener('DOMContentLoaded', openReviewsfromHash);
function openReviewsfromHash() {
  if (window.location.hash === '#reviews') {
    document.querySelector('#reviews-drawer').open = true;
    window.location.hash = "";
  }
}

// Custom description 

const seeMore = document.querySelector('.product-form__see-more');
const content = document.querySelector('.product-form__content');
seeMore?.addEventListener('click', () => {
  content.classList.toggle('product-form__content--is-clamped');
});